/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Commission_Customer_ScopeInputs */



/**
* | output |
* | --- |
* | "Every month recorded for this customer, newest first." |
*
* @param {Partner_Admin_Commission_Customer_ScopeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_customer_scope = /** @type {((inputs?: Partner_Admin_Commission_Customer_ScopeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Customer_ScopeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle für diesen Kunden erfassten Monate, neueste zuerst.")
	return /** @type {LocalizedString} */ ("Every month recorded for this customer, newest first.")
});